var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"about"},[_c('div',{staticClass:"title"},[_vm._v("\n\t\t\t"+_vm._s(_vm.title)+"\n\t\t")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }